// 组件
import importImg from '@/components/importImg.vue'
// 接口
import * as suppliersApi from '@/services/suppliers.js'
import * as shopItemsApi from '@/services/shop-items.js'
import * as shopsApi from '@/services/shops.js'
import * as shopCategoriesApi from '@/services/shop-categories.js'
import * as shopSubCategoriesApi from '@/services/shop-sub-categories.js'
import * as shopItemLabelsApi from '@/services/shop-item-labels.js'
import { getShopItemSites, getShopItemItemables, getWholesalePricingTiers } from '@/services/product.js'
import { getUserGroupSimpleList } from '@/services/members.js'

// 其他
import dataDictionary from '@/utils/data-dictionary.js'
import constant from '@/utils/constant.js'
import verifyRules from '@/utils/verify-rules/index.js'
import loading from '@/utils/loading.json'
import quillConfig from '@/utils/quill-config'
import Utils from '@/utils/Utils.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    importImg
  },
  data () {
    return {
      // appName: process.env.VUE_appName,
      dataDictionary,
      constant,
      verifyRules: verifyRules(this),
      quillOption: quillConfig,
      shopList: [],
      supplierList: [],
      itemTypeList: [],
      categoriesList: [],
      subCategoriesList: [],
      globalLabelsList: [],
      itemablesList: [],
      packInfoList: [],
      siteList: [],
      userGroupList: [],
      wholesalePrice: [],
      wholesalePriceArr: [],
      showPricingTier: false,
      mainForm: {
        itemTypeSelect: {
          disabled: true,
          loading: false
        },
        categorieSelect: {
          loading: false
        },
        subCategorieSelect: {
          loading: false
        },
        data: {
          online: true,
          recommend: false,
          refrigerated: false,
          frozen_product: false,
          non_halal: false,
          support_seven_days_return: false,
          searchable: true,
          free_delivery: false,
          show_in_related_clients: false,
          wholesale_type: 'wholesale',
          after_sales_window: null,
          online_time: null,
          rank: null,
          shop_id: null,
          site_id: null,
          // supplier_id: null,
          item_type: null,
          itemable_id: null,
          category_ids: [],
          shop_sub_category_ids: [],
          name: null,
          name_en: null,
          init_sale: null,
          maximum_limit_per_user: null,
          short_description: null,
          short_description_en: null,
          description: null,
          description_en: null,
          global_labels: null,
          special_attributes: [],
          special_labels_attributes: [],
          invisible_labels_attributes: [],
          images_attributes: [],
          notices_attributes: [],
          shop_item_stocks_attributes: [
            {
              shop_item_stock_suppliers_attributes: [
                {
                  price_f: null,
                  supplier_id: null
                }
              ]
            }
          ],
          shop_item_preferences_attributes: [],
          multiple_preferences: false
        }
      },
      wholesaleTypeList: [
        {
          value: 'retail',
          name: this.$t('form.product.retail')
        },
        {
          value: 'wholesale',
          name: this.$t('form.product.wholesale')
        },
        {
          value: 'retail_and_wholesale',
          name: this.$t('form.product.retailAndwholesale')
        }
      ]
    }
  },
  watch: {
    'mainForm.data.special_labels_attributes': function () {
      const _this = this
      _this.resetVerifyRules()
    },
    'mainForm.data.invisible_labels_attributes': function () {
      const _this = this
      _this.resetVerifyRules()
    },
    'mainForm.data.notices_attributes': function () {
      const _this = this
      _this.resetVerifyRules()
    },
    'mainForm.data.shop_item_stocks_attributes': function () {
      const _this = this
      _this.resetVerifyRules()
    },
    'mainForm.data.shop_item_preferences_attributes': function () {
      const _this = this
      _this.resetVerifyRules()
    }
  },
  computed: {
    ...mapGetters([
      'appName'
    ])
  },
  created () { },
  mounted () {
    getShopItemSites().then(res => {
      this.siteList = res.data
    })
    const _this = this
    const initRequest1 = shopsApi.getShopsSimpleList().then(res => {
      _this.shopList = res.data.shops
      return res
    }).catch(err => err)
    // const initRequest2 = shopItemsApi.getItemTypeList().then(res => {
    //   _this.itemTypeList = res.data.item_type_list
    //   return res
    // }).catch(err => err)
    const initRequest3 = suppliersApi.getSimpleList().then(res => {
      _this.supplierList = res.data.suppliers
      return res
    }).catch(err => err)
    const initRequest4 = shopItemLabelsApi.getShopItemSimpleList().then(res => {
      _this.globalLabelsList = res.data.global_labels
      return res
    }).catch(err => err)
    const requestArr = [initRequest1, initRequest3, initRequest4]
    if (this.appName.includes('wholesale')) {
      const initRequest5 = getUserGroupSimpleList().then(res => {
        _this.userGroupList = res.data.user_groups
        return res
      }).catch(err => err)
      const initRequest6 = getWholesalePricingTiers().then(res => {
        _this.wholesalePrice = res.data.wholesale_pricing_tiers
        _this.wholesalePriceArr.push(JSON.parse(JSON.stringify(res.data.wholesale_pricing_tiers)))
        return res
      }).catch(err => err)
      requestArr.push(initRequest5)
      requestArr.push(initRequest6)
    }
    _this.setGlobalLoading(true)
    Promise.all(requestArr).then(() => {
      _this.setGlobalLoading(false)
    }).catch(() => {
      _this.setGlobalLoading(false)
    })
  },
  methods: {
    handleChange (data, prop) {
      if (prop === 'name' && !Utils.isNull(data)) {
        this.verifyRules.goodsManagerProductAdd.mainForm.name_en[0].required = false
      }
      if ((prop === 'name' || prop === 'name_en') && Utils.isNull(this.mainForm.data.name) && Utils.isNull(this.mainForm.data.name_en)) {
        this.verifyRules.goodsManagerProductAdd.mainForm.name_en[0].required = true
        this.verifyRules.goodsManagerProductAdd.mainForm.name[0].required = true
      }
      if (prop === 'name_en' && !Utils.isNull(data)) {
        this.verifyRules.goodsManagerProductAdd.mainForm.name[0].required = false
      }
      this.$nextTick(() => {
        this.$refs.mainForm.clearValidate()
      })
    },
    handleStocksChange (data, prop, index, tIndex = -1) {
      if (tIndex === 0) {
        this.mainForm.data.shop_item_stocks_attributes[index].tierX_1 = data
        if (prop === 'tierX_1') {
          if (!Utils.isNull(data)) {
            this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.tierX_1`][0].required = false
          }
          if (Utils.isNull(this.mainForm.data.shop_item_stocks_attributes[index].tierX_1)) {
            this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.tierX_1`][0].required = true
          }
        }
      }
      // if (prop === 'name' && !Utils.isNull(data)) {
      //   this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.name_en`][0].required = false
      // }
      // if ((prop === 'name' || prop === 'name_en') && Utils.isNull(this.mainForm.data.shop_item_stocks_attributes[index].name) && Utils.isNull(this.mainForm.data.shop_item_stocks_attributes[index].name_en)) {
      //   this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.name_en`][0].required = true
      //   this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.name`][0].required = true
      // }
      // if (prop === 'name_en' && !Utils.isNull(data)) {
      //   this.verifyRules.goodsManagerProductAdd.mainForm[`shop_item_stocks_attributes.${index}.name`][0].required = false
      // }
      this.$nextTick(() => {
        this.$refs.mainForm.clearValidate()
      })
    },
    supportAfterSaleService (e) {
      if (this.appName.includes('wholesale')) {
        this.mainForm.data.after_sales_window = e ? 5 : null
      }
    },
    supportWholesaleChange (e) {
      this.showPricingTier = e
    },
    handleTicketChange (data) {
      const arr = this.packInfoList.filter(item => item.value === data)
      if (arr.length > 0) {
        this.mainForm.data.name_en = arr[0].name_zh
        this.mainForm.data.name = arr[0].name_zh
        this.mainForm.data.short_description = arr[0].short_description_zh
        this.mainForm.data.short_description_en = arr[0].short_description_en
      }
    },
    handlePackageChange (data) {
      console.log(this.mainForm.data.item_type)
      if (this.mainForm.data.item_type !== 'package') return
      this.handleTicketChange(data)
    },
    getName () {
      if (this.mainForm.data.item_type === dataDictionary['003']['002'].code) {
        return dataDictionary['003']['002'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['004'].code) {
        return dataDictionary['003']['004'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['005'].code) {
        return dataDictionary['003']['005'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['006'].code) {
        return dataDictionary['003']['006'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['007'].code) {
        return dataDictionary['003']['007'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['008'].code) {
        return dataDictionary['003']['008'].name
      } else if (this.mainForm.data.item_type === dataDictionary['003']['009'].code) {
        return dataDictionary['003']['009'].name
      } else if (this.mainForm.data.item_type === 'multi_park_ticket') {
        return this.$t('menu.multiParkTickets')
      } else if (this.mainForm.data.item_type === 'bundle_ticket') {
        return this.$t('menu.tPackage')
      } else if (this.mainForm.data.item_type === 'single_ticket') {
        return this.$t('menu.ticketPackage')
      }
    },
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = _this.$loading(loading) : _this.$store.state.app.loading.close()
    },
    resetVerifyRules () {
      const _this = this
      _this.verifyRules = verifyRules(_this)
      this.handleChange(this.mainForm.data.name, 'name')
      this.handleChange(this.mainForm.data.name_en, 'name_en')
      if (this.mainForm.data.shop_item_stocks_attributes.length > 0) {
        this.mainForm.data.shop_item_stocks_attributes.forEach((stock, stockIndex) => {
          this.handleStocksChange(stock.name, 'name', stockIndex)
          this.handleStocksChange(stock.name_en, 'name', stockIndex)
        })
      }
      _this.$nextTick(() => {
        _this.$refs.mainForm.clearValidate()
      })
    },
    getSpecialLabelsAttributesDefaultData () {
      return {
        name: null,
        name_en: null
      }
    },
    getInvisibleLabelsAttributesDefaultData () {
      return {
        name: null,
        name_en: null
      }
    },
    getNoticesAttributesDefaultData () {
      return {
        title: null,
        title_en: null,
        display_order: null,
        detail: null,
        detail_en: null
      }
    },
    getShopItemStocksAttributesDefaultData () {
      const param = {
        online: true,
        name: null,
        name_en: null,
        sku_id: null,
        price_f: null,
        cost_price_f: null,
        line_price_f: null,
        saling_stock: null,
        warning_stock: null,
        shop_item_stock_suppliers_attributes: []
        // inventory_quantity: 1
      }
      if (this.appName !== 'fooyo') {
        Object.assign(param, {
          inventory_quantity: 1
        })
      }
      if (this.appName.includes('wholesale')) {
        Object.assign(param, {
          tierX_1: null
        })
      }
      return param
    },
    getShopItemPreferencesAttributesDefaultData () {
      return {
        name: null,
        display_order: null,
        min_count: null,
        max_count: null,
        preference_options_attributes: []
      }
    },
    getPreferenceOptionsAttributesDefaultData () {
      return {
        name: null,
        price: null
      }
    },
    getShopItemStockSuppliersAttributesDefaultData () {
      return {
        supplier_id: null,
        price_f: null
      }
    },
    handleShopItemStockSuppliersAddBtnClick (index) {
      const _this = this
      _this.mainForm.data.shop_item_stocks_attributes[index].shop_item_stock_suppliers_attributes.push(_this.getShopItemStockSuppliersAttributesDefaultData())
      _this.resetVerifyRules()
    },
    handleShopItemStockSuppliersDeleteBtnClick (data, index, supplier_index) {
      const _this = this
      if (data._destroy !== undefined) {
        _this.mainForm.data.shop_item_stocks_attributes[index].shop_item_stock_suppliers_attributes[supplier_index]._destroy = true
      } else {
        _this.mainForm.data.shop_item_stocks_attributes[index].shop_item_stock_suppliers_attributes.splice(supplier_index, 1)
      }
      _this.resetVerifyRules()
    },
    handleMainFormSpecialLabelsAddBtnClick () {
      const _this = this
      _this.mainForm.data.special_labels_attributes.push(_this.getSpecialLabelsAttributesDefaultData())
    },
    handleMainFormSpecialLabelsItemDelBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.special_labels_attributes.splice(index, 1)
    },
    handleMainFormInvisibleLabelsAddBtnClick () {
      const _this = this
      _this.mainForm.data.invisible_labels_attributes.push(_this.getInvisibleLabelsAttributesDefaultData())
    },
    handleMainFormInvisibleLabelsItemDelBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.invisible_labels_attributes.splice(index, 1)
    },
    handleMainFormNoticesAddBtnClick () {
      const _this = this
      _this.mainForm.data.notices_attributes.push(_this.getNoticesAttributesDefaultData())
    },
    handleMainFormNoticesItemDelBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.notices_attributes.splice(index, 1)
    },
    handleMainFormShopItemStocksAddBtnClick () {
      const _this = this
      _this.mainForm.data.shop_item_stocks_attributes.push(_this.getShopItemStocksAttributesDefaultData())
      _this.wholesalePriceArr.push(JSON.parse(JSON.stringify(_this.wholesalePrice)))
    },
    handleMainFormShopItemStocksDelBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.shop_item_stocks_attributes.splice(index, 1)
      _this.wholesalePriceArr.splice(index, 1)
    },
    handleMainFormShopItemPreferencesAddBtnClick () {
      const _this = this
      _this.mainForm.data.shop_item_preferences_attributes.push(_this.getShopItemPreferencesAttributesDefaultData())
    },
    handleMainFormShopItemPreferencesDelBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.shop_item_preferences_attributes.splice(index, 1)
    },
    handleMainFormPreferenceOptionsAddBtnClick (data, index) {
      const _this = this
      _this.mainForm.data.shop_item_preferences_attributes[index].preference_options_attributes.push(_this.getPreferenceOptionsAttributesDefaultData())
      _this.resetVerifyRules()
    },
    handleMainFormPreferenceOptionsDelBtnClick (subData, data, subIndex, index) {
      const _this = this
      _this.mainForm.data.shop_item_preferences_attributes[index].preference_options_attributes.splice(subIndex, 1)
    },
    handleMainFormSiteSelectChange (val) {
      getShopItemItemables(this.mainForm.data.item_type, this.mainForm.data.shop_id, this.mainForm.data.site_id).then(res => {
        this.packInfoList = res.data.item_type_list
        this.mainForm.data.itemable_id = null
        this.mainForm.data.name_en = null
        this.mainForm.data.name = null
        this.mainForm.data.short_description = null
        this.mainForm.data.short_description_en = null
      })
    },
    handleMainFormShopSelectChange (val) {
      const _this = this
      if (val === '') {
        _this.itemTypeList = []
        _this.mainForm.data.itemable_id = null
        _this.mainForm.itemTypeSelect.disabled = true
        return false
      }
      _this.categoriesList = []
      _this.subCategoriesList = []
      _this.mainForm.data.category_ids = []
      _this.mainForm.data.shop_sub_category_ids = []
      _this.mainForm.categorieSelect.loading = true
      _this.mainForm.subCategorieSelect.loading = true
      _this.mainForm.itemTypeSelect.loading = true
      _this.mainForm.itemTypeSelect.disabled = false
      shopCategoriesApi.getSimpleListByShopId({
        shop_id: val
      }).then(res => {
        _this.mainForm.categorieSelect.loading = false
        _this.categoriesList = res.data.shop_categories
      }).catch(() => {
        _this.mainForm.categorieSelect.loading = false
      })
      shopSubCategoriesApi.getSimpleListByShopId({
        shop_id: val
      }).then(res => {
        _this.mainForm.subCategorieSelect.loading = false
        _this.subCategoriesList = res.data.shop_sub_categories
      }).catch(() => {
        _this.mainForm.subCategorieSelect.loading = false
      })
      shopItemsApi.getItemTypeListByShop({
        shop_id: val
      }).then(res => {
        _this.mainForm.itemTypeSelect.loading = false
        _this.itemTypeList = res.data.item_types
      }).catch(() => {
        _this.mainForm.itemTypeSelect.loading = false
      })
    },
    handleMainFormImgChange (fileData) {
      const _this = this
      if (fileData && fileData.length > 0) {
        _this.mainForm.data.images_attributes = fileData.map(item => {
          return {
            remote_image_url: item.url
          }
        })
      } else {
        _this.mainForm.data.images_attributes = []
      }
    },
    handleMainFormShopItemStocksImgChange (fileData, data, index) {
      const _this = this
      if (fileData && fileData.length > 0) {
        _this.mainForm.data.shop_item_stocks_attributes[index].remote_image_url = fileData[0].url
      } else {
        _this.mainForm.data.shop_item_stocks_attributes[index].remote_image_url = null
      }
    },
    handleMainFormItemTypeSelectChange (val) {
      const _this = this
      _this.mainForm.data.maximum_limit_per_user = null
      _this.mainForm.data.special_attributes = []
      _this.mainForm.data.special_labels_attributes = []
      _this.mainForm.data.invisible_labels_attributes = []
      _this.mainForm.data.images_attributes = []
      _this.mainForm.data.notices_attributes = []
      _this.mainForm.data.shop_item_stocks_attributes = []
      _this.mainForm.data.shop_item_preferences_attributes = []
      _this.mainForm.data.itemable_id = null
      _this.mainForm.data.site_id = null
      _this.mainForm.data.name = null
      _this.mainForm.data.name_en = null
      _this.mainForm.data.short_description = null
      _this.mainForm.data.short_description_en = null
      _this.mainForm.itemTypeSelect.loading = true
      _this.resetVerifyRules()
      shopItemsApi.getShopItemsItemables({
        item_type: val,
        shop_id: _this.mainForm.data.shop_id
      }).then(res => {
        _this.mainForm.itemTypeSelect.loading = false
        _this.itemablesList = res.data.item_type_list
      }).catch(() => {
        _this.mainForm.itemTypeSelect.loading = false
      })
    },
    handleMainFormCancelClick () {
      const _this = this
      _this.$router.go(-1)
    },
    handleMainFormSubmitClick () {
      const _this = this
      _this.$refs.mainForm.validate((valid) => {
        if (valid) {
          let requestParams = {}
          const dataArr = []
          Object.assign(requestParams, _this.mainForm.data)
          if (requestParams.item_type !== null && requestParams.item_type !== undefined) {
            const arr = requestParams.item_type.split('_')
            arr.forEach(res => {
              const name = res.slice(0, 1).toUpperCase() + res.slice(1)
              dataArr.push(name)
            })
            if (requestParams.itemable_type === 'Package') {
              requestParams.itemable_type = 'TicketPackage'
            }
            requestParams.itemable_type = dataArr.join('')
          } else {
            requestParams.itemable_type = requestParams.item_type
          }

          if (['package', 'ticket_package', 'bundle_ticket', 'single_ticket', 'multi_park_ticket'].includes(requestParams.item_type)) {
            requestParams.itemable_type = 'TicketPackage'
          }
          if (['ticket'].includes(requestParams.item_type)) {
            requestParams.itemable_type = 'PackInfo'
          }
          requestParams.global_labels = requestParams.global_labels.join(',')
          requestParams.category_ids = requestParams.category_ids.join(',')
          requestParams.shop_sub_category_ids = requestParams.shop_sub_category_ids.join(',')
          requestParams.special_attributes.forEach(item => {
            requestParams[item] = true
          })
          requestParams.shop_item_stocks_attributes = JSON.parse(JSON.stringify(requestParams.shop_item_stocks_attributes))
          if (this.appName.includes('wholesale')) {
            requestParams.shop_item_stocks_attributes.map((item, index) => {
              if (this.mainForm.data.wholesale_type === 'wholesale' || this.mainForm.data.wholesale_type === 'retail_and_wholesale') {
                item.shop_item_stock_tier_prices_attributes = this.wholesalePriceArr[index].map(tier => {
                  if (tier.price_f || tier.price_f === 0) {
                    return {
                      wholesale_pricing_tier_id: tier.id,
                      price_f: tier.price_f
                    }
                  }
                })
              }
              delete item.tierX_1
            })
          }
          requestParams = {
            shop_item: {
              ...requestParams
            }
          }
          console.log('----requestParams----', requestParams)
          _this.setGlobalLoading(true)
          shopItemsApi.postShopItems(requestParams).then(() => {
            _this.setGlobalLoading(false)
            _this.$message({
              type: 'success',
              message: _this.$t('message.operateSuccess')
            })
            setTimeout(() => {
              _this.$router.push({
                name: 'goodsManagerProductList'
              })
            }, constant.ROUTER_CHANGE_INTERVAL)
          }).catch(() => _this.setGlobalLoading(false))
        } else {
          this.$message.error(this.$t('message.formIsRequire'))
          return false
        }
      })
    }
  }
}
